import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        <div className="flex items-center gap-3">
          <div className="h-2 w-2 rounded-full bg-accent animate-pulse" />
          <span className="mono text-sm tracking-widest">LOADING</span>
        </div>
      </div>
    );
  }
  if (status !== "authed") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
